import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'home',
    },
  },

  {
    name: 'login',
    path: '/login',
    component: () => import('./view/login'),
    meta: {
      title: '登录',
    },
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('./view/register'),
    meta: {
      title: '注册',
    },
  },
  {
    name: 'resetPwd',
    path: '/resetPwd',
    component: () => import('./view/resetPwd'),
    meta: {
      title: '找回密码',
    },
  },
  {
    name: 'home',
    path: '/home',
    component: () => import('./view/home'),
    meta: {
      title: '首页',
      keepAlive: true,
    },
  },
  {
    name: 'mine',
    path: '/mine',
    component: () => import('./view/mine'),
    meta: {
      title: '个人中心',
    },
  },
  {
    name: 'myUsers',
    path: '/myUsers',
    component: () => import('./view/myUsers'),
    meta: {
      title: '我的用户',
    },
  },
  {
    name: 'userInfo',
    path: '/userInfo',
    component: () => import('./view/userInfo'),
    meta: {
      title: '个人信息',
    },
  },
  {
    name: 'editName',
    path: '/editName',
    component: () => import('./view/editName'),
    meta: {
      title: '修改昵称',
    },
  },
  {
    name: 'editPwd',
    path: '/editPwd',
    component: () => import('./view/editPwd'),
    meta: {
      title: '修改密码',
    },
  },
  {
    name: 'myIntegral',
    path: '/myIntegral',
    component: () => import('./view/myIntegral'),
    meta: {
      title: '我的积分',
    },
  },
  {
    name: 'integralTurn',
    path: '/integralTurn',
    component: () => import('./view/integralTurn'),
    meta: {
      title: '积分转让',
    },
  },
  {
    name: 'carryOnStorage',
    path: '/carryOnStorage',
    component: () => import('./view/carryOnStorage'),
    meta: {
      title: '随身仓出库',
    },
  },
  {
    name: 'record',
    path: '/record',
    component: () => import('./view/record'),
    meta: {
      title: '转让记录',
    },
  },
  {
    name: 'order',
    path: '/order',
    component: () => import('./view/order'),
    meta: {
      title: '我的订单',
      keepAlive: true,
    },
  },
  {
    name: 'logistics',
    path: '/logistics',
    component: () => import('./view/logistics'),
    meta: {
      title: '查看物流',
    },
  },
  {
    name: 'addSite',
    path: '/addSite',
    component: () => import('./view/addSite'),
    meta: {
      title: '添加地址',
    },
  },
  {
    name: 'siteList',
    path: '/siteList',
    component: () => import('./view/siteList'),
    meta: {
      title: '收货地址',
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});
router.afterEach((to) => {
  if (to.path == '/home' || to.path == '/order') {
    if (window.history.state && window.history.state.forward) {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
  }
});

export { router };
